import PropertyTypeSection from './PropertyTypeSection';

export default PropertyTypeSection;